import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type AISearchErrorBannerXinglet = XingletInterface;

export const AISearchErrorBanner = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-ai-error-banner'
);
